import { AutocompleteComponent } from './autocomplete/autocomplete.component';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChipAutocompleteComponent } from './chip-autocomplete/chip-autocomplete.component';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ChipAutocompleteInput } from './chip-autocomplete/chip-autocomplete.input';

@NgModule({
  declarations: [
    AutocompleteComponent,
    ChipAutocompleteComponent,
    ChipAutocompleteInput
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressBarModule,
    MatIconModule,
    MatCheckboxModule,
    MatChipsModule
  ],
  exports: [
    AutocompleteComponent,
    ChipAutocompleteComponent
  ]
})
export class AutocompleteModule { }
